import LanguageToggle from './LanguageToggle';

export default LanguageToggle;


// WEBPACK FOOTER //
// ./src/components/LanguageToggle/index.js